import React from 'react';
import { Box, useResponsive } from '@common-fe/common-fe';

import ActivitiesPreview from './ActivitiesPreview';
import FundsPreview from './FundsPreview';

interface Props {}

const InvestmentsActivitiesPreview: React.FC<Props> = () => {
  const { isMobile } = useResponsive();
  return (
    <Box direction={isMobile ? 'column' : 'row'} margin={{ top: isMobile ? 'spacing16' : 'spacing24' }}>
      <FundsPreview />
      <Box pad={isMobile ? { top: 'spacing16' } : { left: 'spacing24' }} />
      <ActivitiesPreview />
    </Box>
  );
};

export default InvestmentsActivitiesPreview;
